module.exports = __webpack_public_path__ + "static/img/game_header1.f2851f74.png";